import { render, staticRenderFns } from "./MonitorManage.vue?vue&type=template&id=40245ab0&scoped=true&"
import script from "./MonitorManage.vue?vue&type=script&lang=js&"
export * from "./MonitorManage.vue?vue&type=script&lang=js&"
import style0 from "./MonitorManage.vue?vue&type=style&index=0&id=40245ab0&prod&lang=css&"
import style1 from "./MonitorManage.vue?vue&type=style&index=1&id=40245ab0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40245ab0",
  null
  
)

export default component.exports